import { z } from "zod";
import { StemSeparationModel } from "./enums";

export const StemModelSchema = z.nativeEnum(StemSeparationModel);
